import { getApiBase } from './apiBase';

export async function fetchDiskInventory() {
  const API = getApiBase();
  const res = await fetch(`${API}/api/disk/inventory`, { credentials: 'include' });
  if (!res.ok) throw new Error(`inventory ${res.status}`);
  return res.json();
}

export async function refreshDiskInstance(instanceId) {
  const API = getApiBase();
  const res = await fetch(`${API}/api/disk/refresh?instanceId=${encodeURIComponent(instanceId)}`, {
    method: 'POST',
    credentials: 'include'
  });
  if (!res.ok) throw new Error(`refresh ${res.status}`);
  return res.json();
}

export function subscribeDiskEvents(onInventory, onDiskUpdate, onContainerUpdate, onBreakdownUpdate, onDockerReport) {
  const API = getApiBase();
  const es = new EventSource(`${API}/api/disk/events`);
  if (typeof onInventory === 'function') {
    es.addEventListener('inventory', (e) => {
      try { onInventory(JSON.parse(e.data)); } catch {}
    });
  }
  if (typeof onDiskUpdate === 'function') {
    es.addEventListener('disk_update', (e) => {
      try { onDiskUpdate(JSON.parse(e.data)); } catch {}
    });
  }
  if (typeof onContainerUpdate === 'function') {
    es.addEventListener('container_sizes_update', (e) => {
      try { onContainerUpdate(JSON.parse(e.data)); } catch {}
    });
  }
  if (typeof onBreakdownUpdate === 'function') {
    es.addEventListener('docker_breakdown_update', (e) => {
      try { onBreakdownUpdate(JSON.parse(e.data)); } catch {}
    });
  }
  if (typeof onDockerReport === 'function') {
    es.addEventListener('docker_report_update', (e) => {
      try { onDockerReport(JSON.parse(e.data)); } catch {}
    });
  }
  return es;
}
